import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { VulnerabilityExampleEdit } from '../VulnerabilityExampleEdit';

export const Route = createFileRoute('/admin-console/platform-content/ai-training/vulnerability-example/create')({
    staticData: {
        breadcrumb: { title: 'Create' },
        ui: { title: 'Create vulnerability example' },
        presentation: 'overlay',
    },
    component: CreateVulnerabilityExample,
});

function CreateVulnerabilityExample() {
    return (
        <PageController route={Route}>
            <VulnerabilityExampleEdit mode="create" />
        </PageController>
    );
}
